import { Injectable, signal } from '@angular/core';

/** sessionStorage key — also cleared by AuthService on logout. */
export const ACTING_BRANCH_STORAGE_KEY = 'factos_acting_branch';

function restore(): number | null {
  const raw = sessionStorage.getItem(ACTING_BRANCH_STORAGE_KEY);
  const id = raw ? Number(raw) : NaN;
  return Number.isFinite(id) ? id : null;
}

/**
 * The branch the user is ACTING as for write flows (prescription/order
 * creation in Orientador). Distinct from the scope filters: scope bounds what
 * the user can SEE; the acting branch says where new work is registered.
 *
 * Chosen once per session (kept in sessionStorage so reloads keep it) and
 * validated against the user's scope by the consumer before use.
 */
@Injectable({ providedIn: 'root' })
export class ActingBranchService {
  readonly branchId = signal<number | null>(restore());

  select(id: number): void {
    this.branchId.set(id);
    sessionStorage.setItem(ACTING_BRANCH_STORAGE_KEY, String(id));
  }

  clear(): void {
    this.branchId.set(null);
    sessionStorage.removeItem(ACTING_BRANCH_STORAGE_KEY);
  }
}
